import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8080'
})

// Request interceptor - dodaj API key
axiosInstance.interceptors.request.use(
    (config) => {
        const apiKey = localStorage.getItem('fiscal_api_key')
        if (apiKey) {
            config.headers['X-API-Key'] = apiKey
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor - hendluj greške
axiosInstance.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                // Nevalidan/istekao API key → login
                localStorage.removeItem('fiscal_api_key')
                localStorage.removeItem('fiscal_user')
                window.location.href = '/#/login'
            }
            // 402 - pretplata istekla, ne redirektuj, pustimo komponentu da prikaže poruku
            // 403 - nema permisiju, pustimo komponentu da hendluje
        }
        return Promise.reject(error)
    }
)

export default axiosInstance